import React from 'react';
import PropTypes from 'prop-types';

import Tracks from '.';
import Element from './Element';

const DRAG_THRESHOLD = 5;

const Track = ({ time, elements, isOpen, tracks, clickElement, onDragStart, dragAndDropReservation, onDrop, room, onCellClick }) => {
    const mouseDownX = React.useRef(null);
    const plusRef = React.useRef(null);
    const timelineRectRef = React.useRef(null);

    return (
    <div
        onMouseMove={(e) => {
            if (!onCellClick || !plusRef.current) return;
            if (!timelineRectRef.current) {
                const el = document.querySelector('.rt-timeline');
                if (!el) return;
                timelineRectRef.current = el.getBoundingClientRect();
            }
            const relX = e.clientX - timelineRectRef.current.left;
            const date = time.fromX(relX);
            const dayStart = new Date(date);
            dayStart.setHours(0, 0, 0, 0);
            const dayEnd = new Date(dayStart.getTime() + 86400000);
            const cellStyle = time.toStyleLeftAndWidth(dayStart, dayEnd);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const isPast = dayStart < today;
            const dayKey = dayStart.getTime();
            const isOccupied = room?.occupiedCheckInDays?.has(dayKey);
            if (isPast || isOccupied) {
                plusRef.current.style.display = 'none';
                return;
            }
            const centerX = parseFloat(cellStyle.left) + parseFloat(cellStyle.width) / 2;
            plusRef.current.style.left = centerX + 'px';
            plusRef.current.style.display = 'block';
        }}
        onMouseLeave={() => {
            if (plusRef.current) plusRef.current.style.display = 'none';
            timelineRectRef.current = null;
        }}
        onMouseDown={(e) => {
            mouseDownX.current = e.clientX;
        }}
        onDragOver={(e) => {
            e.preventDefault();
        }}
        onDrop={(e) => {
            e.preventDefault();
            if(room?.id){
              const roomInfoId = Number(room.id)
              onDrop(roomInfoId);
            }
        }}
        onClick={(e) => {
            if (!onCellClick || !room?.id) return;
            if (mouseDownX.current !== null && Math.abs(e.clientX - mouseDownX.current) > DRAG_THRESHOLD) return;
            const timelineEl = document.querySelector('.rt-timeline');
            if (!timelineEl) return;
            const relX = e.clientX - timelineEl.getBoundingClientRect().left;
            const date = time.fromX(relX);
            onCellClick(Number(room.id), date);
        }}
        className="tr-track"
        style={{ position: 'relative', cursor: onCellClick ? 'pointer' : undefined }}
    >
        {onCellClick && (
            <div ref={plusRef} style={{
                display: 'none',
                position: 'absolute',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
                lineHeight: 1,
                zIndex: 0,
            }}>
                <i className="fa fa-plus color-primary" style={{ opacity: 0.2 }} />
            </div>
        )}
        <div className="rt-track__elements">
            { elements
                .filter(({ start, end }) => end > start)
                .map((element, index) => (
                    <Element
                        onDragStart={onDragStart}
                        dragAndDropReservation={dragAndDropReservation}
                        key={element.id + index}
                        time={time}
                        clickElement={clickElement}
                        {...element}
                    />
                ))}
        </div>
        {isOpen && tracks && tracks.length > 0 && <Tracks time={time} tracks={tracks} clickElement={clickElement} onCellClick={onCellClick} />}
    </div>
    );
};

Track.propTypes = {
    time: PropTypes.shape({}).isRequired,
    isOpen: PropTypes.bool,
    elements: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tracks: PropTypes.arrayOf(PropTypes.shape({})),
    clickElement: PropTypes.func,
};

export default Track;
